<script>
export default {
  data() {
    return {
      currentPage: 1,
      fields: ["item", "qty_returned", "qty_accepted"],
      items: [],
      type: "gravy",
    };
  },
  methods: {},
  props: ["items_data", "status"],
  mounted() {
    console.log(this.items_data, "ee");
    this.items = this.items_data;
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-tabs>
        <b-tab title="Gravy" @click="() => (type = 'gravy')"></b-tab>
        <b-tab title="Packaging" @click="() => (type = 'packaging')"></b-tab>
      </b-tabs>
      <b-table
        :key="2"
        responsive="sm"
        :items="
          items.filter((f) =>
            type == 'gravy' ? f.gravy != null : f.packaging != null
          )
        "
        :fields="fields"
        :current-page="currentPage"
        :per-page="10"
      >
        <template v-slot:cell(item)="row">
          <p>
            {{
              row.item.gravy != null
                ? row.item.gravy.name
                : row.item.packaging.name
            }}
          </p>
        </template>

        <template v-slot:cell(qty_returned)="row">
          <span>{{ row.item.qty_returned }} pkts</span>
          <span> + {{ row.item.qty_returned_pcs }} pcs</span>
        </template>
        <template v-slot:cell(qty_accepted)="row">
          <div v-if="status == 'accepted' || status == 'completed'">
            <span>{{ row.item.qty_returned_confirmed }} pkts</span>
            <span> + {{ row.item.qty_returned_confirmed_pcs }} pcs</span>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="1"
                v-model="currentPage"
                :total-rows="items.length"
                :per-page="10"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<style></style>
